/**
 * 阿里云 OSS 预签名 PUT：浏览器直传（请求头须与预签名一致）
 */

/**
 * @param {Record<string,string>|Array<{name:string,value?:string}>|null|undefined} raw
 * @returns {Record<string,string>}
 */
export function normalizePresignHeaders (raw) {
  if (!raw) return {}
  if (Array.isArray(raw)) {
    const o = {}
    for (const item of raw) {
      if (item && item.name) {
        o[item.name] = item.value != null ? String(item.value) : ''
      }
    }
    return o
  }
  if (typeof raw === 'object') {
    const o = {}
    for (const [k, v] of Object.entries(raw)) {
      if (v == null) continue
      o[k] = String(v)
    }
    return o
  }
  return {}
}

/**
 * @param {string} url 完整预签名 URL
 * @param {Blob|File} body
 * @param {{ headers?: object, onProgress?: (e: ProgressEvent) => void }} [options]
 * @returns {Promise<void>}
 */
export function putBlobToPresignedUrl (url, body, options = {}) {
  const { headers = {}, onProgress } = options
  const h = normalizePresignHeaders(headers)

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', url, true)
    for (const [k, v] of Object.entries(h)) {
      try {
        xhr.setRequestHeader(k, v)
      } catch {
        /* 部分环境禁止的头部可忽略 */
      }
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve()
      else {
        const msg = xhr.responseText || `PUT 失败 HTTP ${xhr.status}`
        reject(new Error(msg))
      }
    }
    xhr.onerror = () => reject(new Error('直传网络错误'))
    xhr.upload.onprogress = (e) => {
      if (typeof onProgress === 'function') onProgress(e)
    }
    xhr.send(body)
  })
}
